<template>
    <Offcanvas
        v-if="!mdAndGreater"
        ref="mainNavOffcanvasRef"
        placement="start"
        class="offcanvas-main-navigation"
        v-slot="{ hide }">
        <div class="list-group main-navigation-list-group">
            <div>
                <div class="hstack gap-4 py-3">
                    <div class="offcanvas-main-navigation-avatar hstack gap-3 align-items-center">
                        <Avatar
                            :image-url="member?.logo?.url"
                            :text="member?.name"
                            size="default">
                        </Avatar>
                        <div>
                            <p class="subheading mb-0">{{ member?.name }}</p>
                            <div v-if="member?.typeAlias === 'productionHouseMember'" class="subheading-upper text-muted">Production House</div>
                            <div v-else class="subheading-upper text-muted">Freelancer</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <RouterLink
                v-for="item in navLinks"
                @click="hide"
                :to="{ name: item.name }"
                class="hstack gap-4 text-decoration-none py-2"
                active-class="text-primary">
                <Icon :symbol="item.icon" size="m"></Icon>
                <span class="heading-l">{{ item.title }}</span>
            </RouterLink> -->
            <RouterLink
                v-if="member?.approvalStatus?.name === 'Approved'"
                :to="{ name: 'post-login-dashboard' }"
                @click="hide"
                class="hstack gap-4 text-decoration-none py-2"
                active-class="text-primary">
                <Icon symbol="house-fill" size="m"></Icon>
                <span class="heading-l">Home</span>
            </RouterLink>
            <RouterLink
                v-if="member?.approvalStatus?.name === 'Approved'"
                :to="{ name: 'my-portfolios' }"
                @click="hide"
                class="hstack gap-4 text-decoration-none py-2"
                active-class="text-primary">
                <Icon symbol="images" size="m"></Icon>
                <span class="heading-l">My Portfolio</span>
            </RouterLink>
            <RouterLink
                v-if="member?.approvalStatus?.name === 'Approved'"
                :to="{ name: 'my-services' }"
                @click="hide"
                class="hstack gap-4 text-decoration-none py-2"
                active-class="text-primary">
                <Icon symbol="stars" size="m"></Icon>
                <span class="heading-l">My Services</span>
            </RouterLink>
            <RouterLink
                v-if="member?.approvalStatus?.name === 'Approved'"
                :to="{ name: 'my-advertisement' }"
                @click="hide"
                class="hstack gap-4 text-decoration-none py-2"
                active-class="text-primary">
                <Icon symbol="megaphone" size="m"></Icon>
                <span class="heading-l">My Advertisement</span>
            </RouterLink>
            <RouterLink
                :to="{ name: 'settings' }"
                @click="hide"
                class="hstack gap-4 text-decoration-none py-2"
                active-class="text-primary">
                <Icon symbol="gear-fill" size="m"></Icon>
                <span class="heading-l">Settings</span>
            </RouterLink>
            <button
                @click="broadcastPortalStore.logout(true)"
                class="text-danger bg-white border-0 hstack gap-3 text-decoration-none px-1 py-2"
                type="button">
                <Icon symbol="box-arrow-right" class="icon-m"></Icon>
                <span class="heading-l ps-1">Logout</span>
            </button>
        </div>
    </Offcanvas>
    <div v-else class="main-navigation">
        <!-- <Tooltip
            v-for="item in navLinks" class="main-navigation-item ratio ratio-1x1"
            placement="right"
            popper-class="main-navigation-item-tooltip">
            <RouterLink
                :to="{ name: item.name }"
                class="main-navigation-link"
                active-class="active">
                <Icon :symbol="item.icon" class="text-reset" size="l"></Icon>
            </RouterLink>
            <template #popper>
                <span class="caption fw-semibold">{{ item.title }}</span>
            </template>
        </Tooltip> -->
        <Tooltip
            v-if="member?.approvalStatus?.name === 'Approved'"
            class="main-navigation-item ratio ratio-1x1"
            placement="right"
            popper-class="main-navigation-item-tooltip"
        >
            <RouterLink
                :to="{ name: 'post-login-dashboard' }"
                class="main-navigation-link"
                active-class="active">
                <Icon symbol="house-fill" class="text-reset" size="l"></Icon>
            </RouterLink>
            <template #popper>
                <span class="caption fw-semibold">Home</span>
            </template>
        </Tooltip>
        <Tooltip
            v-if="member?.approvalStatus?.name === 'Approved'"
            class="main-navigation-item ratio ratio-1x1"
            placement="right"
            popper-class="main-navigation-item-tooltip"
        >
            <RouterLink
                :to="{ name: 'my-portfolios' }"
                class="main-navigation-link"
                active-class="active">
                <Icon symbol="images" class="text-reset" size="l"></Icon>
            </RouterLink>
            <template #popper>
                <span class="caption fw-semibold">My Portfolio</span>
            </template>
        </Tooltip>
        <Tooltip
            v-if="member?.approvalStatus?.name === 'Approved'"
            class="main-navigation-item ratio ratio-1x1"
            placement="right"
            popper-class="main-navigation-item-tooltip"
        >
            <RouterLink
                :to="{ name: 'my-services' }"
                class="main-navigation-link"
                active-class="active">
                <Icon symbol="stars" class="text-reset" size="l"></Icon>
            </RouterLink>
            <template #popper>
                <span class="caption fw-semibold">My Services</span>
            </template>
        </Tooltip>
        <Tooltip
            v-if="member?.approvalStatus?.name === 'Approved'"
            class="main-navigation-item ratio ratio-1x1"
            placement="right"
            popper-class="main-navigation-item-tooltip"
        >
            <RouterLink
                :to="{ name: 'my-advertisement' }"
                class="main-navigation-link"
                active-class="active">
                <Icon symbol="megaphone" class="text-reset" size="l"></Icon>
            </RouterLink>
            <template #popper>
                <span class="caption fw-semibold">My Advertisement</span>
            </template>
        </Tooltip>
        <Tooltip
            class="main-navigation-item ratio ratio-1x1"
            placement="right"
            popper-class="main-navigation-item-tooltip"
        >
            <RouterLink
                :to="{ name: 'settings' }"
                class="main-navigation-link"
                active-class="active">
                <Icon symbol="gear-fill" class="text-reset" size="l"></Icon>
            </RouterLink>
            <template #popper>
                <span class="caption fw-semibold">Settings</span>
            </template>
        </Tooltip>
    </div>
</template>

<script setup lang="ts">
import { Icon, Offcanvas } from '@/modules/core/components';
import { breakpointsBootstrapV5, useBreakpoints } from '@vueuse/core';
import { Tooltip } from 'floating-vue';
import { Dropdown } from 'floating-vue';
import 'floating-vue/dist/style.css';
import { useMainNavOffcanvas } from './composables';
import Avatar from '@/modules/core/components/avatar.vue';
import { useBroadcastPortalAuthStore } from '../../store';
import { storeToRefs } from 'pinia';


const navLinks = [
    {
        name: 'post-login-dashboard',
        title: 'Home',
        icon: 'house-fill'
    },
    {
        name: 'my-portfolios',
        title: 'My Portfolio',
        icon: 'images'
    },
    {
        name: 'settings',
        title: 'Settings',
        icon: 'gear-fill'
    },
    {
        name: 'my-services',
        title: 'My Services',
        icon: 'stars'
    },
]

const broadcastPortalStore = useBroadcastPortalAuthStore()

const { member } = storeToRefs(broadcastPortalStore);

const breakpoints = useBreakpoints(breakpointsBootstrapV5);
const mdAndGreater = breakpoints.greater('md');


const { mainNavOffcanvasRef } = useMainNavOffcanvas()
</script>

<style lang="scss">

.main-navigation {
    border-right: 1px solid $gray-200;
    width: 72px;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: .5rem;
    gap: .25rem;
    flex-shrink: 0;

    &-link {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: .5rem;
        transition: .15s ease-in-out;
        transition-property: color, backgorund-color;
        color: $gray-500;

        &:hover {
            background-color: rgb($primary, 0.1);
            color: $primary;
        }

        &.active {
            background-color: rgb($primary, 0.15);
            color: $primary;
        }
    }
}

.main-navigation-item-tooltip {
    .v-popper__inner {
        padding: 2px 8px;
        line-height: 1;
    }

    .v-popper__arrow-container {
        display: none;
    }
}

.offcanvas-main-navigation {
    --bs-offcanvas-width: 90vw;

    .offcanvas-main-navigation-avatar {
        .avatar.avatar-default.avatar-alphabet {
            width: 2.25rem !important;
            border-radius: 0.5rem !important;
        }
    }
}

.main-navigation-list-group {
    a {
        color: $text-muted;
    }
}
</style>